import {getApiConfig, getCurrentFabricatorId} from "../../../utilities";
import {PRICING_SET_CATALOGS_LOADING} from "../../../constants/actionTypes";
import {setPricingCatalogs,} from "../pricingActions";
import {toggle_modal} from "../../../actions/A_Popups";

const responseThen = (response) => {
  console.log('success fetching catalogs', response);
  return response
}

const responseCatch = (error) => {
  console.log('error fetching catalogs', error);
  return error
}

export const getPricingCatalogs = (groupName, paramsCatalogName) => {
  return async (dispatch, getState) => {

    dispatch({type: PRICING_SET_CATALOGS_LOADING, payload: {pricingCatalogsLoading: true}})

    const fabricatorId = getCurrentFabricatorId(getState());

    // {fabricatorId:int}/groups/{groupName}/catalogs

    return getApiConfig(`price-list/${fabricatorId}/groups/${groupName}/catalogs`).get()
      .then((response) => {
        console.log('response get catalogs ->', response);
        dispatch({type: PRICING_SET_CATALOGS_LOADING, payload: {pricingCatalogsLoading: false}})
        dispatch(setPricingCatalogs(Array.isArray(response) ? response.map(catalog => {
          if (catalog.name === paramsCatalogName) {
            catalog.isActive = true;
          }
          catalog.newCustomName = catalog.name;
          return catalog
        }).sort((a, b) => (a.id > b.id) ? 1 : -1) : []));
        return response
      })
      .catch((response) => {
        console.log('error get catalogs ->', response);
        dispatch(setPricingCatalogs([]));
        dispatch({type: PRICING_SET_CATALOGS_LOADING, payload: {pricingCatalogsLoading: false}})
        return false
      });
  }
}

export const postSaveNewCatalog = (catalog) => {
  return async (dispatch, getState) => {

    const fabricatorId = getCurrentFabricatorId(getState());
    const {newCustomName, groupName} = catalog;

    return getApiConfig(`price-list/${fabricatorId}/groups/${groupName}/catalogs`).post(newCustomName)
      .then(responseThen)
      .catch(responseCatch);
  }
}

export const getCatalogsToUpdate = (store) => {
  const pricingCatalogsToSave = store.pricingState.pricingCatalogs.filter(catalog => {
    return catalog.needToSaveCatalog
  });
  const pricingCatalogsToUpdate = store.pricingState.pricingCatalogs.filter(catalog => {
    return catalog.needToUpdateCatalog
  });
  return {pricingCatalogsToSave, pricingCatalogsToUpdate}
}

export const saveNewCatalogs = async (dispatch, store) => {
  const {pricingCatalogsToSave, pricingCatalogsToUpdate} = getCatalogsToUpdate(store);
  if (pricingCatalogsToSave.length || pricingCatalogsToUpdate.length) {
    if (pricingCatalogsToSave.some(catalog => !catalog.newCustomName)
      || pricingCatalogsToUpdate.some(catalog => !catalog.newCustomName)) {
      dispatch(toggle_modal(true, "Create a catalog name to save", [{
        text: "Close",
        color: "blue",
        onClick: () => dispatch(toggle_modal(false))
      }]));
      return Promise.resolve()
    }
    for (const pricingCatalogToSave of pricingCatalogsToSave) {
      await dispatch(postSaveNewCatalog(pricingCatalogToSave));
    }
    for (const pricingCatalogToUpdate of pricingCatalogsToUpdate) {
      await dispatch(postUpdateCatalog(pricingCatalogToUpdate));
    }
    dispatch(setPricingCatalogs(store.pricingState.pricingCatalogs.map(catalog => {
      catalog.needToSaveCatalog = false;
      catalog.needToUpdateCatalog = false;
      return catalog
    })));
  }
}

export const postUpdateCatalog = (catalog) => {
  return async (dispatch, getState) => {

    const fabricatorId = getCurrentFabricatorId(getState());

    return getApiConfig(`price-list/${fabricatorId}/catalogs`).post({
      Id: catalog.id,
      GroupName: catalog.groupName,
      Name: catalog.newCustomName,
    }, "", "patch")
      .then(responseThen)
      .catch(responseCatch);
  }
}


export const deleteCatalog = (catalog) => {
  return async (dispatch, getState) => {
    const fabricatorId = getCurrentFabricatorId(getState());
    return getApiConfig(`price-list/${fabricatorId}/catalogs/${catalog.id}`).delete()
      .then(responseThen)
      .catch(responseCatch);
  }
}

export const getAllCatalogs = () => {
  return async (dispatch, getState) => {
    const fabricatorId = getCurrentFabricatorId(getState());
    return getApiConfig(`price-list/${fabricatorId}/catalogs/`).get()
      .then(responseThen)
      .catch(responseCatch);
  }
}
